import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { addSingleCorporateProfile, corporateProfileList, singleCourseAssignToUser } from "../apis/apiHandler";

export const corporateProfile = createAsyncThunk(
    "corporateProfile/list",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await corporateProfileList(payload);

            if (response?.code === 200 || response?.code === 404) {
                return response.data;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const addCorporateProfile = createAsyncThunk(
    "corporateProfile/add",
    async ({ payload }, { rejectWithValue }) => {
        try {
            const response = await addSingleCorporateProfile(payload);

            if (response?.code === 200) {
                return response;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const courseAssign = createAsyncThunk(
    "corporateProfile/course_assign",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await singleCourseAssignToUser(payload);

            if (response?.code === 200) {
                return response;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);


const initialState = {
    loading: false,
    corporateProfileList: [],
    addCorporateProfileData: {},
    courseAssignData: {},
    error: null,
    success: false,
};

const coporateProfileSlice = createSlice({
    name: "corporate profile",
    initialState,

    reducers: {},

    extraReducers: (builder) => {
        builder
            .addCase(corporateProfile.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(corporateProfile.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.corporateProfileList = payload;
                state.success = true;
            })
            .addCase(corporateProfile.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(addCorporateProfile.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(addCorporateProfile.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.addCorporateProfileData = payload;
                state.success = true;
            })
            .addCase(addCorporateProfile.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(courseAssign.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(courseAssign.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.courseAssignData = payload;
                state.success = true;
            })
            .addCase(courseAssign.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })


    },
});

export default coporateProfileSlice.reducer;
